import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingAssets } from 'packages/store/assets/assets.selectors';
import { updateAssetsStatus } from 'packages/store/assets/assets.actions';
import { updateCollectionsThumbnails } from 'packages/store/collections/collections.actions';
import useAssetStatusSubscribe from './useAssetStatusSubscribe';
import useSuperSet from './useSuperSet';

const emptyAssetsIds: string[] = [];

/**
 * Listen for assets thumbnail updates via ws or sse, depending on the flag
 * unsubscribe when component unmounts
 */
export default function useAssetStatusUpdates() {
    const pendingAssets: string[] = useSelector(getPendingAssets);

    const dispatch = useDispatch();

    // prevents unnecessary re-subscriptions when pendingIds change
    // the array stays the same until there is no new items in pendingIds
    const memoizedPendingIds = useSuperSet(pendingAssets);
    const assetIds = pendingAssets.length ? memoizedPendingIds : emptyAssetsIds;

    const subscribe = useAssetStatusSubscribe({
        assetIds,
        // Not memoised on purpose: both hooks hold it in a ref.
        onMessage: ({ items }) => {
            dispatch(updateAssetsStatus(items));
            dispatch(updateCollectionsThumbnails(items));
        },
    });

    useEffect(() => {
        if (!assetIds.length) {
            return;
        }

        return subscribe();
    }, [subscribe, assetIds]);
}
